document.addEventListener('DOMContentLoaded', function () {

    const quizzes = document.querySelectorAll('.section-quiz');

    quizzes.forEach(quiz => {

        /* ---------------- dropdown ---------------- */

        const dropdownButton = quiz.querySelector('.quiz-btn-dropdown .quiz-drop-item.active');
        const dropdownMenu = quiz.querySelector('.quiz-dropdown');
        const dropdownItems = quiz.querySelectorAll('.quiz-dropdown .quiz-drop-item');

        if (dropdownButton) {
            dropdownButton.addEventListener('click', () => {
                dropdownMenu.classList.toggle('active');

                const activeDataDrop = dropdownButton.dataset.drop;

                dropdownItems.forEach(item => {
                    item.classList.toggle('hidden', item.dataset.drop === activeDataDrop);
                });
            });
        }

        dropdownItems.forEach(item => {
            item.addEventListener('click', () => {

                dropdownItems.forEach(i => i.classList.remove('hidden'));

                dropdownMenu.insertBefore(item, dropdownMenu.firstChild);

                const dropdownName = dropdownMenu.dataset.dropdown;

                dropdownButton.textContent = item.textContent;
                dropdownButton.dataset.drop = item.dataset.drop;

                const inputName = `dropdown-${dropdownName}`;

                let inputElement = quiz.querySelector(`input[name="${inputName}"]`);

                if (!inputElement) {
                    inputElement = document.createElement('input');
                    inputElement.type = 'hidden';
                    inputElement.name = inputName;
                    dropdownMenu.appendChild(inputElement);
                }

                inputElement.value = item.dataset.value;

                dropdownMenu.classList.remove('active');
            });
        });

        document.addEventListener('click', e => {
            if (
                dropdownButton &&
                !dropdownButton.contains(e.target) &&
                !dropdownMenu.contains(e.target)
            ) {
                dropdownMenu.classList.remove('active');
            }
        });

        /* ---------------- pagination ---------------- */

        let currentPage = 1;

        const quizPages = quiz.querySelectorAll(".quiz-page");
        const quizCounts = quiz.querySelectorAll(".quiz-count");
        const nextButton = quiz.querySelectorAll(".quiz-btn-next");
        const prevButton = quiz.querySelectorAll(".quiz-btn-prev");
        const lastButton = quiz.querySelector(".quiz-btn");

        function updateActiveState(pageNumber) {

            quizPages.forEach(page => page.classList.remove("active"));
            quizCounts.forEach(count => count.classList.remove("active"));

            const activePage = quiz.querySelector(`.quiz-page[data-page="${pageNumber}"]`);
            const activeCount = quiz.querySelector(`.quiz-count[data-page="${pageNumber}"]`);

            if (activePage) activePage.classList.add("active");
            if (activeCount) activeCount.classList.add("active");

            prevButton.forEach(button => button.style.display = pageNumber === 1 ? "none" : "flex");
            nextButton.forEach(button => button.style.display = pageNumber === quizPages.length ? "none" : "flex");

            if (lastButton) {
                lastButton.style.display = pageNumber === quizPages.length ? "flex" : "none";
            }
        }

        nextButton.forEach(button => {
            button.addEventListener("click", () => {
                if (currentPage < quizPages.length) {
                    currentPage++;
                    updateActiveState(currentPage);
                }
            });
        });

        prevButton.forEach(button => {
            button.addEventListener("click", () => {
                if (currentPage > 1) {
                    currentPage--;
                    updateActiveState(currentPage);
                }
            });
        });

        quizCounts.forEach(count => {
            count.addEventListener("click", () => {

                const selectedCount = parseInt(count.dataset.page);

                currentPage = selectedCount;

                updateActiveState(currentPage);
            });
        });

        updateActiveState(currentPage);

        /* ---------------- radio ---------------- */

        const radioGroups = quiz.querySelectorAll('.section-quiz-two__page--one-list');

        radioGroups.forEach(group => {

            const radios = group.querySelectorAll('input[type="radio"]');

            radios.forEach(radio => {

                radio.addEventListener('change', () => {

                    group.querySelectorAll('.quiz-radio').forEach(label => {
                        label.classList.remove('active');
                    });

                    if (radio.checked) {
                        radio.closest('.quiz-radio').classList.add('active');
                    }

                });

            });

        });

    });

});